import { Component } from 'react'

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { error: null }
  }

  static getDerivedStateFromError(error) {
    return { error }
  }

  render() {
    if (this.state.error) {
      return (
        <div className="public-app flex min-h-screen items-center justify-center p-4 text-center">
          <div className="tma-card w-full max-w-sm p-6" role="alert">
            <p className="text-[20px] font-semibold leading-6 tracking-[-0.04em] text-[var(--tma-text)]">
              Что-то пошло не так
            </p>
            <p className="mt-2 break-words text-[14px] leading-5 text-[var(--tma-text-secondary)]">
              {this.state.error.message || 'Ошибка загрузки приложения'}
            </p>
          </div>
        </div>
      )
    }

    return this.props.children
  }
}
